import { Box } from "@mui/material";
import React from "react";
import { Typography } from "@platform/design-system";

import { RfpListItem } from "../../hooks/useRfpsList";

type DetailRowProps = {
  data: RfpListItem;
};

export const DetailRow: React.FC<DetailRowProps> = ({ data }) => (
  <Box
    sx={{
      display: "grid",
      gridTemplateColumns: "[left gutter] 0.5rem repeat(18,1fr)",
      padding: "1rem 0",
      minHeight: "auto",
      marginLeft: "1rem",
    }}
  >
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gridColumn: "2/10",
        wordBreak: "break-word",
        whiteSpace: "normal",
      }}
    >
      <Typography variant="body-large" mb={0.5}>
        <strong>Products</strong>
      </Typography>
      <Typography variant="body-medium">
        {data.products?.length ? data.products.join(", ") : "No products found"}
      </Typography>
    </Box>

    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gridColumn: "11/18",
        wordBreak: "break-word",
        whiteSpace: "normal",
      }}
    >
      <Typography variant="body-large" mb={0.5}>
        <strong>Carriers</strong>
      </Typography>
      <Typography variant="body-medium">
        {data?.details?.carriers?.length
          ? data?.details?.carriers?.join(", ")
          : "No carriers found"}
      </Typography>
    </Box>
  </Box>
);
